import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import dayjs from 'dayjs';
import useMonthlyInverterGraphStyles from './styles';

const MonthlyInverterGraph = ({ mapinverterData, mapYieldData, Fromdate, key }) => {
  const classes = useMonthlyInverterGraphStyles();
  const [chartData, setchartData] = React.useState({});
  const [selectedMonth, setSelectedMonth] = React.useState('');
  useEffect(() => {
    const date = new Date(Fromdate);
    const monthsdata = (date.getMonth() + 1).toString().padStart(2, '0');
    setSelectedMonth(monthsdata)
  }, [Fromdate, mapinverterData, mapYieldData]);
  useEffect(() => {
    const chartData = {
      series: [
        {
          name: 'Inverter',
          data: mapinverterData

        },
        {
          name: 'Yield',
          data: mapYieldData
        },

      ],
    };
    setchartData(chartData)
  }, [selectedMonth, Fromdate, mapinverterData, mapYieldData]);

  const chartOptions = {
    chart: {
      stacked: true,
      zoom: false,
      toolbar: {
        show: false,

      },
    },
    xaxis: {
      type: "category",
      floating: false,
      tickAmount: 30,
      tickPlacement: 'on',
      labels: {
        show: true,
        rotate: -45,
        rotateAlways: true,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        minHeight: undefined,
        maxHeight: 120,
        style: {
          colors: [],
          fontSize: '12px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 400,
          cssClass: 'apexcharts-xaxis-label',
        },
        offsetX: 0,
        offsetY: 0,
        format: 'dd/MM',
        formatter: function (value, timestamp, opts) {
          return dayjs(value).format("DD-MM")
        },
        datetimeUTC: false,
        datetimeFormatter: {
          year: 'yyyy',
          month: "MMM 'yy",
          day: 'dd MMM',
          hour: 'HH:mm',
        },
      }
    },
    yaxis: {
      labels: {
        formatter: function (value, timestamp, opts) {
          return value.toFixed(2)
        },
      }
    },
    legend: {
      position: 'top',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 0,
        borderRadiusApplication: 'around',
        borderRadiusWhenStacked: 'last',
        columnWidth: '70%',
        barHeight: '70%',
        distributed: false,
        rangeBarOverlap: true,
        rangeBarGroupRows: false,
        hideZeroBarsWhenGrouped: false,
        isDumbbell: false,
        dumbbellColors: undefined,
        isFunnel: false,
        isFunnel3d: true,
        colors: {
          ranges: [{
            from: 0,
            to: 0,
            color: undefined
          }],
          backgroundBarColors: [],
          backgroundBarOpacity: 1,
          backgroundBarRadius: 0,
        },
        dataLabels: {
          position: 'center',
          maxItems: 100,
          hideOverflowingLabels: true,
          orientation: 'vertical',
          total: {
            enabled: false,
            formatter: function (value, timestamp, opts) {
              return value.toFixed(2)
            },
            offsetX: 0,
            offsetY: 0,
            style: {
              color: '#373d3f',
              fontSize: '12px',
              fontWeight: 600
            }
          }
        }
      }
    },
    dataLabels: {
      enabled: false // Hide data labels
    }
  };
  return <div className={classes.root}>
    <div style={{ textAlign: 'center' }} >Generation (kwh) Analysis</div>
    {chartData?.series?.[0]?.data && chartData?.series?.[1]?.data &&
      <div key={key}>
        <ReactApexChart
          options={chartOptions}
          series={chartData.series}
          type="bar"
          height={350}
        />
      </div>
    }
  </div>;
};

MonthlyInverterGraph.propTypes = {};

export default MonthlyInverterGraph;
